import htmlComponent from "htmlcomponent";

export default function (dom, opts) {
    let options = {
        activeCls: 'active',
        activeSel: '[data-select]',
        showFilterSel: '[data-filter]',
        ...opts
    };

    const singleElement = Array.from(dom.querySelectorAll(options.activeSel));
    const filterElements = Array.from(dom.querySelectorAll(options.showFilterSel));
    const subFilter = Array.from(document.querySelectorAll('[data-subfilter]'));
    const subFilterElements = Array.from(document.querySelectorAll('[data-subfilter] .news-filter__single'));

    function init() {
        showActive();
    }

    function showActive() {
        singleElement.forEach(el => {
            el.addEventListener('click', () => {
                
                /* toggle visibility */
                singleElement.forEach(item => {
                    item.classList.remove(options.activeCls);
                });

                /* reset subfilters */
                subFilter.forEach(item => {
                    item.classList.remove('show');
                });
                
                if(document.querySelector('[data-subfilter="'+ el.getAttribute("data-filter") +'"]')) {
                    document.querySelector('[data-subfilter="'+ el.getAttribute("data-filter") +'"]').classList.add("show");
                }
                el.classList.add(options.activeCls);

            })

            subFilterElements.forEach(item => {
                item.addEventListener('click', () => {
                    subFilterElements.forEach(subf => { subf.classList.remove(options.activeCls) });
                    item.classList.add(options.activeCls);
                });
            });

        })
    }

    init()

}
